// extracted by mini-css-extract-plugin
export default {"root":"_39it-","custom-icon-button-size":"_1ky9K","customIconButtonSize":"_1ky9K"};